window.addEventListener('message', (event) => {
  if (event.origin.toString().search('.ceros.com') === -1) {
    return;
  }

  let eventData;
  try {
    eventData = JSON.parse(event.data);
  } catch (e) {
    // console.log(e);
  }

  if (eventData !== undefined && eventData.documentWidth && eventData.documentHeight) {
    const header = document.getElementById('masthead');
    const iframe = document.querySelector('.ceros-experience');
    const iframeContainer = iframe.parentElement;
    const zoomRate = iframeContainer.offsetWidth / eventData.documentWidth;
    iframe.style.height = '100%';
    iframeContainer.style.height = `${eventData.documentHeight * zoomRate}px`;
    iframeContainer.style.padding = '0';
    iframeContainer.style.overflow = 'hidden';

    window.scrollTo(0, iframeContainer.offsetTop - header.offsetHeight);
  }
});
